import { post, get, put, deleteApi } from './axiosFun';
//部门新增
export const deptAdd = (params) => { return post("/sys/sys-dept/deptAdd", params) };
//部门编辑
export const deptEdit = (params) => { return post("/sys/sys-dept/deptEdit", params) };
//部门删除
export const deptRemove = (params) => { return post("/sys/sys-dept/deptRemove", params) };
//部门详情
export const deptDetail = (deptId) => { return get(`/sys/sys-dept/deptDetail/${deptId}`) };

//部门成员
export const deptMemberPage = (params,header={}) => { return post("/sys/sys-dept/deptMemberPage", params,header) };
export const deptList = (params,header={}) => { return post("/sys/sys-dept/deptList", params,header) };
//部门树分页
export const deptTreePage = (params) => { return post("/sys/sys-dept/deptTreePage", params,) };
//部门树
export const deptTree = (params) => { return post("/sys/sys-dept/deptTree", params,) };


// WEBPACK FOOTER //
// ./src/api/dept.js